import { Component, Host, h, Prop, Event, EventEmitter, State } from '@stencil/core';

export interface PageChangedEvent {
  start: number;
}

@Component({
  tag: 'cr-pagination',
  styleUrl: 'cr-pagination.css',
  shadow: true,
})
export class CrPagination {
  @Prop() start: number = 0;
  @Prop() total: number = 0;
  @Prop() pageSize: number = 10;

  @State() currentPage: number = 1;

  @Event() pageChanged: EventEmitter<PageChangedEvent>;

  render() {
    return (
      <Host>
        <div class="container">
          <div class="message">{this.message()}</div>
          <div class="buttons">
            <button class="button" disabled={this.backDisabled()} onClick={this.handlePageDown}>
              <cr-caret-left disabled={this.backDisabled()} size="small" class="icon" />
            </button>
            <button class="button" disabled={this.forwardDisabled()} onClick={this.handlePageUp}>
              <cr-caret-right disabled={this.forwardDisabled()} size="small" />
            </button>
          </div>
        </div>
      </Host>
    );
  }

  private handlePageUp = () => {
    this.currentPage = this.currentPage + 1;
    const nextStart = this.start + this.pageSize;
    this.pageChanged.emit({ start: nextStart });
  };

  private handlePageDown = () => {
    this.currentPage = this.currentPage - 1;
    const nextStart = this.start - this.pageSize;
    this.pageChanged.emit({ start: nextStart });
  };

  private remainingResults = (): number => this.total - this.start - this.pageSize;

  private backDisabled = (): boolean => this.start === 0;

  private forwardDisabled = (): boolean => this.remainingResults() <= 0;

  private message = (): string => {
    return `${this.start + 1} - ${this.start + Math.min(this.remainingResults() + this.pageSize, this.pageSize)} of ${this.total} items`;
  };
}
